import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "subcribe-to-newsletter"
}
const _hoisted_2 = ["innerHTML"]

import { ref, computed, onMounted } from 'vue';

  import useContext from '@/composables/useContext';
  import { useCartFunctions } from '@/composables/useCartFunctions';

  import Checkbox from '../forms/Checkbox.vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'SubscribeToNewsletter',
  setup(__props) {

  const { cart } = useContext();
  const { toggleNewsletterSubscribtion } = useCartFunctions();

  const newsletterConsent = computed(() => {
    return cart.value?.newsletterConsent;
  });

  const subscribeToNewsletterText = computed(() => {
    if (!newsletterConsent.value?.subscribeToNewsletterText) {
      return '';
    }
    if (!newsletterConsent.value?.pageLinkUrl || !newsletterConsent.value?.pageLinkText) {
      return newsletterConsent.value.subscribeToNewsletterText;
    }

    return `${newsletterConsent.value.subscribeToNewsletterText} <a href="${newsletterConsent.value.pageLinkUrl}" target="_blank"> ${newsletterConsent.value.pageLinkText} </a>`;
  });

  const freeShippingText = computed(() => {
    return newsletterConsent.value?.freeShippingText || '';
  });

  const isSubcribed = ref(false);

  onMounted(() => {
    isSubcribed.value = cart.value?.newsletterConsent?.agreedToConsent || false;
  });

return (_ctx: any,_cache: any) => {
  return (_unref(subscribeToNewsletterText))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_unref(freeShippingText))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "subcribe-to-newsletter__free-shipping",
              innerHTML: _unref(freeShippingText)
            }, null, 8, _hoisted_2))
          : _createCommentVNode("", true),
        _createVNode(Checkbox, {
          text: _unref(subscribeToNewsletterText),
          modelValue: isSubcribed.value,
          "onUpdate:modelValue": _unref(toggleNewsletterSubscribtion)
        }, null, 8, ["text", "modelValue", "onUpdate:modelValue"])
      ]))
    : _createCommentVNode("", true)
}
}

})